import { EP } from './../configs/constant';
import { getPath } from "../helpers/handleUrl";
import { IProvinceAddressResponse } from '../types/address';
import axiosThirdService, { AxiosThirdService } from "./axiosThirdService";
class ProvinceService {
    readonly service: AxiosThirdService;
    constructor() {
        this.service = axiosThirdService;
    }
    async getProvinces() {
        // return this.service.get<IProvinceAddressResponse>("https://api.salekit.com:3039/api/v1/address/provinces")
        return this.service.get<IProvinceAddressResponse>("https://api.salekit.com:3039/api/v1/address/provinces");
    }
}
const provinceService = new ProvinceService();
export default provinceService;